export const CheckIcon = () => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5309 0.37583L5.88778 7.11367L2.47078 4.10138C2.37155 4.01329 2.23682 3.96384 2.09629 3.96384C1.95572 3.96384 1.82098 4.0133 1.72196 4.10124L1.15601 4.60015C1.05608 4.68763 1 4.80639 1 4.93028C1 5.05419 1.05611 5.17298 1.15587 5.26027L5.51733 9.10514C5.61659 9.19322 5.75131 9.24268 5.89183 9.24268C6.03235 9.24268 6.16705 9.19322 6.26606 9.10532L14.844 1.54348C14.9439 1.4561 15 1.3373 15 1.21335C15 1.08957 14.944 0.970907 14.8445 0.883641L14.2785 0.377545L14.2765 0.37583C14.0687 0.198291 13.7386 0.198291 13.5309 0.37583Z"
      fill="white"
      stroke="white"
      strokeWidth="0.25"
    />
  </svg>
);
